import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';

const Phone = (props) =>
{	
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [numbers, SetNumbers] = useState([{id:'', number:'', type:''}]);
	const [firstLoad, SetFirstLoad] = useState(true);

	useEffect(() =>
	{
		if(props.defaultValue && props.defaultValue.length && firstLoad)
		{
			SetNumbers(props.defaultValue);
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [props]);

	useEffect(() =>
	{
		if(props.onChange)
		{
			let validNumbers = Validation();
			props.onChange(validNumbers);
		}
	// eslint-disable-next-line
	}, [numbers]);

	const Validation = () =>
	{
		let validNumbers = []; 
		if(numbers.length !== 0)
		{
			for(const key in numbers)
			{
				if(numbers[key]['number'].trim() !== '' && numbers[key]['number'].trim().length > 3)
				{
					validNumbers.push(numbers[key]);
				}
			}
		}
		return validNumbers;
	}

	const HandleChange = (e, key) =>
	{
		const newPhoneArray = [...numbers];
		switch(e.target.type)
		{
			case "checkbox": newPhoneArray[key]['type'] = e.target.checked ? e.target.name : ''; break;
			case "text": newPhoneArray[key]['number'] = e.target.value; break;
			default: return e;
		}
		SetNumbers(newPhoneArray);
	}

	const HandleDelete = (key) =>
	{
		const newPhoneArray = [...numbers];
		newPhoneArray.splice(key, 1);
		SetNumbers(newPhoneArray);
	}

	const AddPhone = () =>
	{
		const newPhoneArray = [...numbers];
		const data = {id: '', number: '', type: ''};
		newPhoneArray.push(data);
		SetNumbers(newPhoneArray);
	}
	
	return <>
	{numbers.map((data, index) => {
		return <div key={index} className='w-full flex mb-5 items-center'>
				<div className='me-3 cursor-pointer'>
					{index === 0 ? <i className="py-4 px-2 fa fa-plus fa-lg bg-primary text-white rounded-md" onClick={AddPhone}></i>
					: <i className='py-4 px-2 fa fa-trash-alt fa-lg text-danger rounded-md' onClick={()=>HandleDelete(index)}></i>}
				</div>
				<div className='grow'>
					<input type='text' name='phone' value={data.number} onBlur={() => { if (props.onBlur) { props.onBlur(numbers); } }} onChange={(e)=>HandleChange(e, index)} />
				</div>
				<div className='flex items-center mx-2 gap-1'>
					<input type='checkbox' onChange={(e)=>HandleChange(e, index)} name='Mobile' checked={data.type === 'Mobile'}/><span className='inline-block text-xs'>{language.MOBILE}</span>
				</div>
			</div>
		})
	}
	</>
};

export default Phone;